module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-21-25325e43c7064fb37caa2ef87f3ed971.jpg";